"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParametersOfSearchAPI = exports.convertResponseOfSearchAPI = void 0;
/**
 * 查詢 回傳欄位值轉換
 * @param response
 * @returns
 */
const convertResponseOfSearchAPI = (response) => {
    const { object } = response;
    const newData = object === null || object === void 0 ? void 0 : object.map((item) => {
        const { uuid, deptCode, deptName } = item;
        const response = {
            dataId: uuid,
            departmentCode: deptCode,
            departmentName: deptName
        };
        return response;
    });
    return {
        data: object !== null ? newData : []
    };
};
exports.convertResponseOfSearchAPI = convertResponseOfSearchAPI;
/**
 * 查詢 請求參數欄位轉換
 * @param request
 * @returns
 */
const getParametersOfSearchAPI = (request) => {
    const { id } = request;
    return {
        userId: id
    };
};
exports.getParametersOfSearchAPI = getParametersOfSearchAPI;
